export function buildSystemUsersTableModel(dtoRows) {
  return dtoRows.map((row) => ({
    id: row.id,
    firstName: row.firstName,
    lastName: row.lastName,
    email: row.email,
    disabled: Boolean(row.disabled),
    fullName: `${row.firstName} ${row.lastName}`.trim() || '-',
  }));
}

